const nps = {
  nps: {
    npsBreakdown: 'NPSの内訳',
    npsScore: 'NPSスコア',
    npsSpread: 'NPSスプレッド',
    npsDashboard: 'NPSダッシュボード',
    npsDetails: 'NPS詳細',
    npsTrend: 'NPSの動向',
    verbatims: '逐語',
    timePeriod: '期間：',
    to: '～',
    pastMonths: '過去 %{month} ヶ月',
    ratingType: '評価タイプ',
    systemId: 'システム ID',
    systemName: 'システム名',
    rating: '評価',
    comments: 'コメント',
    all: 'すべて',
    promoter: '推奨者',
    promoters: '推奨者',
    detractor: '批判者',
    detractors: '批判者',
    passive: '中立者',
    noData: '該当データなし',
    npsDashboardTooltip: {
      whatIs: 'ネット・プロモーター・スコアとは？',
      npsDefine:
        "ネット・プロモーター・スコア（Net Promoter Score）とは、顧客がある会社を他の人に薦める意欲を測る-100から100までの指数です。これは、顧客の総合的な満足度を測るための代用品として使用されます。",
      questionIs: `質問は、「0から10のスケールで、友人や同僚に当社を薦める可能性はどのくらいありますか？」という表現で行われます。顧客が選択した数字に基づいて、以下のいずれかのカテゴリーに分類されます："批判者"、"中立者"、"推奨者"。スコアの内訳：0 - 6：批判者、7 - 8：中立者、9 - 10：推奨者`,
      determined: `ネット・プロモーター・スコア（NPS）は、推奨者である顧客の割合から、批判者である顧客の割合を差し引いて決定されます。生成されるのは、ネット・プロモーター・スコアと呼ばれる-100から100の間のスコアです。`,
      how: `EnphaseはどのようにNPSを決定するのですか？`,
      shownBelow: `Enphaseは、以下の画面に示すように、Enlightenモバイルアプリで評価を提供してもらうように住宅所有者に促します。提供された評価に基づいて、上記のようにNPSが決定されます。`
    },
    timePeriodTooltip: `デフォルトの期間は過去13ヶ月です。過去13ヶ月間のNPSスコアが入手できない場合は、入手可能な最初の月からのスコアが含まれます。`,
    verbatimsTooltip: `ここに掲載されているコメントはすべて、設置業者との共有に同意したシステム所有者からのものです。`,
    jan: "1月",
    feb: "2月",
    mar: "3月",
    apr: "4月",
    may: "5月",
    jun: "6月",
    jul: "7月",
    aug: "8月",
    sep: "9月",
    oct: "10月",
    nov: "11月",
    dec: "12月",
    ofTotal: '全体の',
    ratings: '評価',
    numberOfReviews: 'レビュー数',
    date: '日付',
    between0And10: '0から10の間の値を入力してください。',
    lessThan50: '文字数は50文字以内です',
    npsBasedOnScore: `%{count} の評価に基づく %{score} のNPS`
  }
};

export default nps;
